if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        if (!button) return;
        this._onClick = this._onClick?.bind?.(this) || ((e) => this.onClick(e));
        button.addEventListener('click', this._onClick);
      }

      disconnectedCallback() {
        const button = this.querySelector('button');
        if (button && this._onClick) button.removeEventListener('click', this._onClick);
      }

      onClick(event) {
        const button = event.currentTarget; // always the <button>, not an inner <span>
        const parentDisplay = button.closest('.parent-display');
        if (!parentDisplay) return;

        // Toggle the two labels
        const showMore = button.querySelector('.label-show-more');
        const showLess = button.querySelector('.label-show-less');
        showMore?.classList.toggle('hidden');
        showLess?.classList.toggle('hidden');

        // Toggle the extra items
        parentDisplay
          .querySelectorAll('.show-more-item')
          .forEach((item) => item.classList.toggle('hidden'));

        // Update aria-expanded
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));

        // Focus the first newly visible input, if any
        const nextInput = parentDisplay.querySelector('.show-more-item:not(.hidden) input');
        nextInput?.focus();
      }
    }
  );
}